export const validate = values => {
  const errors = {}

  if (values.password !== values.repeatPassword) {
    errors.password = 'Your password and confirmation password do not match.'
    errors.repeatPassword =
      'Your password and confirmation password do not match.'
  }
  return errors
}
